exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ a[href=\"https://www.froala.com/wysiwyg-editor?k=u\"] {\r\n    display: none !important;\r\n    position: absolute;\r\n    top: -99999999px;\r\n  }\r\n\r\n  /deep/ .fr-wrapper>div>a { display: none!important; }\r\n\r\n  /deep/ a[href*=\"froala\"]{\r\n    display: none !important;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/email/mail.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/email/mail.css
// module chunks = main